export default "__VITE_ASSET__C$8Y2K8s__"